import {ErrorHandler, NgModule} from "@angular/core";
import {FormsModule} from "@angular/forms";
import {HttpModule} from "@angular/http";
import {BrowserModule} from "@angular/platform-browser";
import {AppMinimize} from "@ionic-native/app-minimize";
import {Calendar} from "@ionic-native/calendar";
import {Dialogs} from "@ionic-native/dialogs";
import {File} from "@ionic-native/file";
import {FileTransfer} from "@ionic-native/file-transfer";
import {InAppBrowser} from "@ionic-native/in-app-browser";
import {Keyboard} from "@ionic-native/keyboard";
import {OneSignal} from "@ionic-native/onesignal";
import {SplashScreen} from "@ionic-native/splash-screen";
import {StatusBar} from "@ionic-native/status-bar";
import {ThemeableBrowser} from "@ionic-native/themeable-browser";
import {IonicStorageModule} from "@ionic/storage";
import {IonicApp, IonicErrorHandler, IonicModule} from "ionic-angular";
import {IonicImageViewerModule} from 'ionic-img-viewer';
import "moment/locale/nl";
import {InlineSVGModule} from "ng-inline-svg";
// modules
import {ComponentsModule} from "../components/components.module";
import {DirectivesModule} from "../directives/directives.module";
import {PipesModule} from "../pipes/pipes.module";
import {AgendaService} from "../services/agenda.service";
import {AppointmentService} from "../services/appointment.service";
// services
import {AuthorizedService} from "../services/authorized.service";
import {CategoryService} from "../services/category.service";
import {DocumentService} from "../services/document.service";
import {GroupService} from "../services/group.service";
import {InschrijvenService} from "../services/inschrijven.service";
import {NewsService} from "../services/news.services";
import {NewsletterService} from "../services/newsletter.service";
import {NotificationService} from "../services/notification.service";
import {PhotoService} from "../services/photo.services";
import {PushSubscriptionService} from "../services/push-subscription.service";
import {ReportService} from "../services/report.service";
import {SettingsService} from "../services/settings.service";
import {StaticPageService} from "../services/static-page.service";
import {SurveyService} from "../services/survey.service";
import {TagService} from "../services/tag.service";
import {UrlOpenerProvider} from '../services/url-opener.service';
import {MyApp} from "./app.component";

@NgModule({
  declarations: [
    MyApp,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp, {
      locationStrategy: 'hash'
    }),
    IonicStorageModule.forRoot(),
    HttpModule,
    BrowserModule,
    FormsModule,
    ComponentsModule,
    DirectivesModule,
    PipesModule,
    InlineSVGModule.forRoot({
      baseUrl: null
    }),
    IonicImageViewerModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp
  ],
  providers: [
    {provide: ErrorHandler, useClass: IonicErrorHandler},

    AppMinimize,
    Calendar,
    Dialogs,
    File,
    InAppBrowser,
    Keyboard,
    OneSignal,
    SplashScreen,
    StatusBar,
    ThemeableBrowser,
    FileTransfer,

    AuthorizedService,
    AgendaService,
    AppointmentService,
    CategoryService,
    DocumentService,
    GroupService,
    InschrijvenService,
    NewsService,
    NewsletterService,
    NotificationService,
    PhotoService,
    PushSubscriptionService,
    ReportService,
    SettingsService,
    StaticPageService,
    SurveyService,
    TagService,
    UrlOpenerProvider
  ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts